//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class PersonMaritalService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[PersonMarital.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-marital/detail', {'params':params});
	};

	//GeneratorFlag:[PersonMarital.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-marital/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}